// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1auYR","log":"ModalInventoryLogs_log__3LFbD","date":"ModalInventoryLogs_date__1NuAt","userName":"ModalInventoryLogs_userName__Nb_sT"};